/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow_left': {
    width: 16,
    height: 16,
    viewBox: '0 0 256 256',
    data: '<path pid="0" d="M172.5 1.3L46 127.8l126.5 126.4 37.9-38-88.4-88.4 88.4-88.5z"/>'
  }
})
